export default "__VITE_ASSET__CbHXMjk9__"